import React from "react"
import classnames from "classnames"
import styles from "./Image360.less"
import aframe from 'AtomicUtils/aframe'

class Image360 extends React.Component {
  constructor(props) {
    super(props)

    if (process && process.env && process.env.NODE_ENV === 'test'){
      this.randomIdName = 1
    } else {
      this.randomIdName = `image360${Math.floor(Math.random() * 1000)}`
    }

    this.state = {
      idName: this.randomIdName,
      loading: true
    }

    this.aframe = null
  }

  componentDidMount() {
    this.aframe = new aframe()

    this.aframe.loadAframe({
      callback: () => {
        setTimeout(() => {
          this.setState({
            loading: false
          })
        }, 400)
      }
    })
  }

  render() {
    const { src } = this.props
    const { idName, loading } = this.state

    return (
      <div
        id={idName}
        className={classnames({
          [styles.Image360]: true
        })}>
        {
          !loading &&
          <a-scene embedded="true">
            <a-entity rotation="0 180 0">
              <a-camera touch-controls look-controls="reverseMouseDrag: true; reverseTouchDrag: true"></a-camera>
            </a-entity>
            <a-sky src={src} ></a-sky>
          </a-scene>
        }
      </div>
    )
  }
}

export default Image360



// WEBPACK FOOTER //
// ./src/AtomicContainers/Image360/Image360.jsx